// extracted by mini-css-extract-plugin
export default {"report_item":"styles_report_item__9qsk7","report_item_text":"styles_report_item_text__DX5ZK","report_item_data":"styles_report_item_data__jlI-b","history":"styles_history__Ta6WJ"};